import ImageZoom from '../../commons/ImageZoom';
import './Loreal.css';

const Loreal = () => {
    return (
      <div className="portfolio">
        <header className="portfolio-header">
          <h1>Gala L'Oréal</h1>
          <p>Présentation du projet</p>
        </header>
  
        <section className="portfolio-section">
          <h2>Fonctionnalités</h2>
          <div className="portfolio-projects">
            <div className="project">
            <ImageZoom style={{height: '200px', width: 'auto'}} alt={''} src={'./assets/loreal-chat.jpg'}/>
              <h3 className='mt-3'>Chat en ligne</h3>
              <p>Les invités avaient la possibilité d'envoyer des messages rediffusés sur un écran géant, le tout géré par une modération.</p>
            </div>
            <div className="project">
            <ImageZoom style={{height: '200px', width: 'auto'}} alt={''} src={'./assets/loreal-avatar.jpg'}/>
              <h3 className='mt-3'>Création d'avatars</h3>
              <p>Les invités pouvaient également créer des avatars à leur image grâce à l'intégration de l'API Ready Player Me. Ces avatars étaient visibles dans le chat à côté des messages.</p>
            </div>
            <div className="project">
            <ImageZoom style={{height: '200px', width: 'auto'}} alt={''} src={'./assets/loreal-borne.jpg'}/>
              <h3 className='mt-3'>Bornes d'authentification</h3>
              <p>Les utilisateurs devaient se connecter à l'application depuis un QR-code qu'ils pouvaient obtenir dans une liste déroulante depuis des bornes disposées dans le hall d'entrée.</p>
            </div>
          </div>
        </section>
  
        <section className="portfolio-section">
          <h2>À propos du projet</h2>
          <p>
          Lors du prestigieux gala organisé par L’Oréal, j’ai eu l’opportunité de développer une application web complète, conçue pour offrir une expérience interactive et immersive pour tous les participants.
          <br />
          L’application permettait tout d’abord un check-in fluide des invités, facilitant ainsi l’accueil et le suivi des présences en temps réel. Une fonctionnalité innovante permettait également à chaque utilisateur de créer son propre avatar personnalisé, offrant ainsi une touche ludique et unique à l’événement.
          <br />
          Un plan des tables interactif a été intégré, permettant à chaque invité de visualiser en un coup d'œil l’emplacement de sa table directement depuis l’application, améliorant ainsi l’orientation et l’organisation globale de l’événement.
          <br />
          Un chat en ligne a été ajouté, permettant aux invités de rester connectés et d’échanger tout au long de la soirée, renforçant ainsi l’interaction sociale. De plus, les utilisateurs avaient la possibilité de voter pour leurs animations favorites, rendant l’événement plus participatif et engageant.
          <br />
          L’application offrait également une roue de hasard, une fonctionnalité ludique permettant aux invités de remporter des surprises et de dynamiser davantage l’événement.
          <br />
          Pour garantir une gestion optimale de l’événement, des hôtesses équipées d’iPads avaient accès à un tableau de bord leur permettant de suivre en temps réel l’affluence, gérer les inscriptions et assister les invités tout au long de la soirée.
          <br />
          D’autres fonctionnalités ont été intégrées, comme des notifications en temps réel pour informer des moments forts de la soirée, ainsi qu’un accès direct au programme et aux moments clés du gala.
          <br />
          Cette solution digitale a non seulement optimisé l’organisation, mais aussi transformé l’expérience des invités en leur permettant de participer activement tout au long de l’événement. 🚀✨
          </p>
          <img style={{maxWidth: '360px'}} width={'100%'} src="./assets/loreal.png" alt="Moi" className="about-image" />
        </section>
  
        <footer className="portfolio-footer">
          <a href="mailto:julien.j.1999@hotmail.com">Contactez-moi: julien.j.1999@hotmail.com</a>
        </footer>
      </div>
    );
  };
  
  export default Loreal;